// Mirrors FinkitUserPagesPermissions.RiskMonitoing.ConsolidatedExposure / NopThresholds
// (policy strings use the correct "RiskMonitoring" spelling).
const CE = 'User.RiskMonitoring.ConsolidatedExposure';
const NT = 'User.RiskMonitoring.NopThresholds';

export const ConsolidatedExposurePermissions = {
  default: CE,
  clientsNopTab: `${CE}.ClientsNop`,
  firmNopTab: `${CE}.FirmNop`,
  lpNopTab: `${CE}.LpNop`,
  rtNopTab: `${CE}.RtNop`,
  volumeMatchingTab: `${CE}.VolumeMatching`,
  expectedEodSwapTab: `${CE}.ExpectedEodSwap`,
  byCcy: `${CE}.ByCcy`,
  byUniqueId: `${CE}.ByUniqueId`,
  autoMap: 'User.RiskMonitoring.AutoMap',
  nopThresholds: NT,
  nopThresholdsCreate: `${NT}.Create`,
  nopThresholdsEdit: `${NT}.Edit`,
  nopThresholdsDelete: `${NT}.Delete`,
} as const;
